import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { text as textClass } from './text.module.css';
export const Text = forwardRef(({ children, className, size = 16, weight, maxWidth, textAlign = 'start', as: Wrapper = 'p', fluid = true, style, ...props }, forwardedRef) => {
    const cssVars = {
        '--max-width': maxWidth,
        '--text-align': textAlign
    };
    return (React.createElement(Wrapper, { ref: forwardedRef, "data-text-size": size, "data-text-weight": weight, "data-text-is-fluid": fluid, className: clsx(textClass, className), style: { ...cssVars, ...style }, ...props }, children));
});
Text.displayName = 'Text';
